"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DomainContext", {
  enumerable: true,
  get: function get() {
    return _Domain["default"];
  }
});
Object.defineProperty(exports, "appWithDomain", {
  enumerable: true,
  get: function get() {
    return _Domain.appWithDomain;
  }
});
Object.defineProperty(exports, "getServerSideDomainContextProps", {
  enumerable: true,
  get: function get() {
    return _Domain.getServerSideDomainContextProps;
  }
});
Object.defineProperty(exports, "getClientSideDomainContextProps", {
  enumerable: true,
  get: function get() {
    return _Domain.getClientSideDomainContextProps;
  }
});
Object.defineProperty(exports, "useRouter", {
  enumerable: true,
  get: function get() {
    return _useRouter["default"];
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("next/link"));

var _Domain = _interopRequireWildcard(require("./Domain"));

var _useRouter = _interopRequireDefault(require("./hooks/useRouter"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// typescript import
// import
// definition
var main = /*#__PURE__*/_react["default"].memo(function Link(_ref) {
  var href = _ref.href,
      target = _ref.target,
      children = _ref.children,
      disabled = _ref.disabled,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["href", "target", "children", "disabled"]);
  if (disabled) return /*#__PURE__*/_react["default"].cloneElement(children, {
    onClick: function onClick(e) {
      e.preventDefault();
    }
  });
  return target === '_blank' ? /*#__PURE__*/_react["default"].cloneElement(children, {
    onClick: function onClick(e) {
      e.preventDefault();
      window.open(href);
    }
  }) : /*#__PURE__*/_react["default"].createElement(_link["default"], (0, _extends2["default"])({}, props, {
    href: href
  }), children);
});

main.displayName = "Link"
var _default = /*#__PURE__*/main;
exports["default"] = _default;